module.exports = __webpack_public_path__ + "static/img/7.714f42c3.png";